import { useCallback } from 'react';
import { QueryFunctionContext, UseInfiniteQueryOptions } from 'react-query';
import { useSDK } from '../useSDK';
import { GetCustomAttributesResponse } from '../../sdk';
import { useFetchAllPages } from './useFetchAllPages';

const CUSTOM_ATTRIBUTES_QUERY_KEY = 'custom-attributes-v3';
const FETCH_LIMIT = 200;
const FIVE_MINUTES = 5 * 60 * 1000;

export const useGetCustomAttributes = (
  options?: UseInfiniteQueryOptions<GetCustomAttributesResponse, unknown>,
  limit = FETCH_LIMIT,
) => {
  const sdk = useSDK();
  const queryFn = useCallback(
    ({ pageParam = { limit, offset: 0 } }: QueryFunctionContext) =>
      sdk.CustomAttributes.getAll({ ...pageParam, filterStatus: ['active'] }),
    [sdk, limit],
  );
  return useFetchAllPages({
    ...options,
    queryKey: [CUSTOM_ATTRIBUTES_QUERY_KEY],
    queryFn,
    staleTime: FIVE_MINUTES,
  });
};
